export const WORKSPACE_SIMULATION_POLICY_PREVIEW_OPEN =
  "tessera:workspace-simulation-policy-preview-open";
export const WORKSPACE_SIMULATION_POLICY_PREVIEW_HIDE =
  "tessera:workspace-simulation-policy-preview-hide";
export const WORKSPACE_SIMULATION_POLICY_PREVIEW_VISIBILITY =
  "tessera:workspace-simulation-policy-preview-visibility";

export type WorkspaceSimulationPolicyPreviewOpenDetail = {
  simulationId: string;
  title: string;
  /** Serialized policy tree used by the simulation (same shape as strategy policy view). */
  policy: unknown;
};

export type WorkspaceSimulationPolicyPreviewVisibilityDetail = {
  open: boolean;
  simulationId: string | null;
};

function trimId(value: string): string {
  return value.trim();
}

export function dispatchWorkspaceSimulationPolicyPreviewOpen(
  detail: WorkspaceSimulationPolicyPreviewOpenDetail
): void {
  if (typeof window === "undefined") return;
  const simulationId = trimId(detail.simulationId);
  if (!simulationId) return;
  window.dispatchEvent(
    new CustomEvent<WorkspaceSimulationPolicyPreviewOpenDetail>(
      WORKSPACE_SIMULATION_POLICY_PREVIEW_OPEN,
      {
        detail: {
          simulationId,
          title: detail.title.trim() || "Policy",
          policy: detail.policy,
        },
      }
    )
  );
}

export function dispatchWorkspaceSimulationPolicyPreviewHide(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(WORKSPACE_SIMULATION_POLICY_PREVIEW_HIDE));
}

export function dispatchWorkspaceSimulationPolicyPreviewVisibility(
  detail: WorkspaceSimulationPolicyPreviewVisibilityDetail
): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<WorkspaceSimulationPolicyPreviewVisibilityDetail>(
      WORKSPACE_SIMULATION_POLICY_PREVIEW_VISIBILITY,
      { detail }
    )
  );
}
